function SmallTCPLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.7px"
      height="28px"
      fill="none"
      viewBox="0 0 77 70"
    >
      <path
        className="fill-white"
        d="M60.397 0l-2.31 4H10.742v14h-4V0h53.655zM72.742 4H62.706l2.31-4h11.726v70h-26v-4h22V4zM46.742 66h-36V52h-4v18h40v-4zM17.464 24.949v-2.738H0v2.738h7.067V48h3.367V24.949h7.03zM20.573 28.316c-1.135 1.998-1.702 4.255-1.702 6.771s.567 4.773 1.702 6.771c1.134 1.998 2.676 3.564 4.625 4.699 1.973 1.11 4.156 1.665 6.549 1.665 2.812 0 5.266-.666 7.363-1.998 2.096-1.357 3.626-3.268 4.588-5.735h-4.033c-.716 1.554-1.752 2.75-3.108 3.589-1.332.814-2.936 1.221-4.81 1.221-1.801 0-3.417-.42-4.847-1.258-1.431-.839-2.553-2.023-3.367-3.552-.814-1.554-1.221-3.355-1.221-5.402 0-2.072.407-3.873 1.22-5.402.815-1.554 1.937-2.75 3.368-3.589 1.43-.839 3.046-1.258 4.847-1.258 1.874 0 3.478.42 4.81 1.258 1.356.839 2.392 2.035 3.108 3.589h4.033c-.962-2.491-2.492-4.415-4.588-5.772-2.097-1.357-4.551-2.035-7.363-2.035-2.393 0-4.576.567-6.55 1.702-1.948 1.135-3.49 2.713-4.624 4.736z"
      ></path>
      <path
        className="fill-white"
        fillRule="evenodd"
        d="M62.252 35.124c1.48-1.43 2.22-3.219 2.22-5.365 0-2.22-.765-4.033-2.294-5.439-1.505-1.406-3.713-2.109-6.623-2.109H47.23V48h3.367V37.233h4.958c3.009 0 5.241-.703 6.697-2.109zm-2.553-1.887c-.888.814-2.27 1.221-4.144 1.221h-4.958v-9.472h4.958c3.65 0 5.476 1.591 5.476 4.773 0 1.505-.444 2.664-1.332 3.478z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default SmallTCPLogo;
